import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ptCommon from "./locales/pt/common.json";
import ptHome from "./locales/pt/home.json";
import ptAuth from "./locales/pt/auth.json";
import ptClubsLanding from "./locales/pt/clubsLanding.json";
import ptPlayersLanding from "./locales/pt/playersLanding.json";
import ptPresentation from "./locales/pt/presentation.json";
import ptBooking from "./locales/pt/booking.json";
import ptClubs from "./locales/pt/clubs.json";
import ptTournaments from "./locales/pt/tournaments.json";
import ptProfile from "./locales/pt/profile.json";
import ptLayout from "./locales/pt/layout.json";
import ptAdmin from "./locales/pt/admin.json";
import ptPages from "./locales/pt/pages.json";
import ptTerms from "./locales/pt/terms.json";
import ptMyLessons from "./locales/pt/myLessons.json";
import ptMyMakeups from "./locales/pt/myMakeups.json";
import ptMyContracts from "./locales/pt/myContracts.json";

import enCommon from "./locales/en/common.json";
import enHome from "./locales/en/home.json";
import enAuth from "./locales/en/auth.json";
import enClubsLanding from "./locales/en/clubsLanding.json";
import enPlayersLanding from "./locales/en/playersLanding.json";
import enPresentation from "./locales/en/presentation.json";
import enBooking from "./locales/en/booking.json";
import enClubs from "./locales/en/clubs.json";
import enTournaments from "./locales/en/tournaments.json";
import enProfile from "./locales/en/profile.json";
import enLayout from "./locales/en/layout.json";
import enAdmin from "./locales/en/admin.json";
import enPages from "./locales/en/pages.json";
import enTerms from "./locales/en/terms.json";
import enMyLessons from "./locales/en/myLessons.json";
import enMyMakeups from "./locales/en/myMakeups.json";
import enMyContracts from "./locales/en/myContracts.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt: {
        common: ptCommon, home: ptHome, auth: ptAuth, clubsLanding: ptClubsLanding,
        playersLanding: ptPlayersLanding, presentation: ptPresentation, booking: ptBooking,
        clubs: ptClubs, tournaments: ptTournaments, profile: ptProfile, layout: ptLayout,
        admin: ptAdmin, pages: ptPages, terms: ptTerms, myLessons: ptMyLessons,
        myMakeups: ptMyMakeups, myContracts: ptMyContracts,
      },
      en: {
        common: enCommon, home: enHome, auth: enAuth, clubsLanding: enClubsLanding,
        playersLanding: enPlayersLanding, presentation: enPresentation, booking: enBooking,
        clubs: enClubs, tournaments: enTournaments, profile: enProfile, layout: enLayout,
        admin: enAdmin, pages: enPages, terms: enTerms, myLessons: enMyLessons,
        myMakeups: enMyMakeups, myContracts: enMyContracts,
      },
    },
    fallbackLng: "pt",
    defaultNS: "common",
    ns: ["common", "home", "auth", "clubsLanding", "playersLanding", "presentation", "booking", "clubs", "tournaments", "profile", "layout", "admin", "pages", "terms", "myLessons", "myMakeups", "myContracts"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

export default i18n;
